module.exports = __webpack_public_path__ + "img/item18.96eae233.png";